<template>
  <b-modal
    id="trackvideo-setting"
    ref="trackvideoSettingRef"
    size="sm"
    :modal-class="`mc-modal-options ${!$store.state.sidebar.sideBarOpen ? 'mc-panel-close' : ''}`"
    hide-header
    hide-footer
    scrollable
    no-close-on-backdrop
    hide-backdrop
    no-enforce-focus
    centered
  >
    <h4 class="mc-modal-info__head">
      {{ $t('global.object.configuration') }}
      <i class="mc-fa icon-outline_close" @click="close"></i>
    </h4>
    <div v-show="isMobileView" class="mb-4">
      <span
        v-if="hasAccess(['b3n-trackvision-toggle-video-status:read'])"
        class="form-switch form-switch-md me-trackvision__switch-new-view-wrapper d-flex justify-content-between"
      >
        {{ $t('global.newView') }}
        <input v-model="isNewView" class="form-check-input" type="checkbox" />
      </span>
    </div>
    <div class="mc-modal-info__options">
      <h6 class="mb-1">
        {{ $t('global.object.fleetList') }}
      </h6>
      <McAlert variant="info" :text="$t('trackVideo.modalTooltip')" withIcon />
      <div class="mt-2 font-size-12">
        <div class="form-check form-switch mb-1">
          <label class="form-check-label">{{ $t('global.object.hullNo') }}</label>
          <input
            v-model="form.label_hull"
            class="form-check-input"
            type="checkbox"
            switch
            @change="setting()"
          />
        </div>
        <div class="form-check form-switch mb-1">
          <label class="form-check-label">{{ $t('global.object.driverName') }}</label>
          <input
            v-model="form.label_driver"
            class="form-check-input"
            type="checkbox"
            switch
            @change="setting()"
          />
        </div>
        <div class="form-check form-switch">
          <label class="form-check-label">{{ $t('global.object.fleetClassification') }}</label>
          <input
            v-model="form.label_classification"
            class="form-check-input"
            type="checkbox"
            switch
            @change="setting()"
          />
        </div>
        <div class="mc-modal-info__options-item">
          <McRadioButton
            v-for="options in classificationOptions"
            :key="options.value"
            v-model="form.classification_type"
            name="classification-type"
            :initialValue="options.value"
            class="mb-1"
            :disabled="!form.label_classification"
            @change="setting()"
          >
            <template #label>
              <label
                class="form-check-label"
                :disabled="!form.label_classification"
                @click="handleClickLabel(options.value)"
              >
                {{ options.text }}
              </label>
            </template>
          </McRadioButton>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import McAlert from '@/components/McAlert'
import { mapGetters } from 'vuex'
import McRadioButton from '@/components/McRadioButton'

export default {
  components: {
    McAlert,
    McRadioButton,
  },
  props: {
    isMobileView: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const isNewView = JSON.parse(localStorage.getItem('live-streaming-switch-view-on')) ?? true
    const displayCOnfig = JSON.parse(localStorage.getItem('trackvideo-set-display'))
    let form = {
      label_classification: true,
      label_driver: true,
      label_hull: false,
      classification_type: 'category',
    }
    if (displayCOnfig) {
      form = displayCOnfig
    } else {
      localStorage.setItem('trackvideo-set-display', JSON.stringify(form))
    }
    return {
      isNewView: isNewView,
      form,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    classificationOptions() {
      return [
        {
          text: this.$t('global.object.fleetCategory'),
          value: 'category',
        },
        {
          text: this.$t('global.object.fleetType'),
          value: 'type',
        },
        {
          text: this.$t('global.object.manufacture'),
          value: 'manufacture',
        },
      ]
    },
  },
  mounted() {
    this.$store.commit('video/setFleetListDisplay', this.form)
  },
  methods: {
    close() {
      this.$bvModal.hide('trackvideo-setting')
    },
    handleClickLabel(value) {
      this.form.classification_type = value
      this.setting()
    },
    setting() {
      localStorage.setItem('trackvideo-set-display', JSON.stringify(this.form))
      this.$store.commit(
        'video/setFleetListDisplay',
        JSON.parse(localStorage.getItem('trackvideo-set-display'))
      )
    },
  },
}
</script>
